/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()


;(() => {
    const dialog = document.querySelector('#checkout-upsell-dialog')
    if (!dialog) return
    const cards = Array.from(dialog.querySelectorAll('[data-upsell-card]'))
    const emptyMessage = dialog.querySelector('[data-upsell-empty]')
    let checkoutOrigin = 'cart'
    let skipNextSubmit = false
    let opening = false

    const checkoutButton = () => {
        const selector = checkoutOrigin === 'drawer'
            ? '#offcanvas-cart button[name="checkout"]'
            : '#cart button[name="checkout"]'
        return document.querySelector(selector) || document.querySelector('button[name="checkout"]')
    }

    const updateEmptyMessage = () => {
        if (emptyMessage) emptyMessage.hidden = cards.some(card => !card.hidden)
    }

    const continueToCheckout = () => {
        if (dialog.open) dialog.close()
        const button = checkoutButton()
        if (button?.form && typeof button.form.requestSubmit === 'function') {
            skipNextSubmit = true
            button.form.requestSubmit(button)
            window.setTimeout(() => { skipNextSubmit = false }, 1500)
        } else {
            window.location.assign(dialog.dataset.checkoutUrl)
        }
    }

    const syncCartOffers = async () => {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
        if (!response.ok) throw new Error('Could not read cart')
        const cart = await response.json()
        cards.forEach(card => {
            if (cart.items.some(item => String(item.product_id) === card.dataset.productId)) card.hidden = true
        })
        updateEmptyMessage()
        return cards.some(card => !card.hidden)
    }

    const openForCheckout = async button => {
        if (opening) return
        opening = true
        checkoutOrigin = button.closest('#offcanvas-cart') ? 'drawer' : 'cart'
        try {
            if (!await syncCartOffers()) {
                continueToCheckout()
                return
            }
            dialog.showModal()
        } catch (error) {
            dialog.showModal()
        } finally {
            opening = false
        }
    }

    const interceptCheckout = (event, button) => {
        if (!button || skipNextSubmit || dialog.open || !cards.length) return
        if (button.form && !button.form.checkValidity()) return
        event.preventDefault()
        event.stopImmediatePropagation()
        openForCheckout(button)
    }

    document.addEventListener('click', event => {
        const button = event.target.closest('button[name="checkout"]')
        if (button) interceptCheckout(event, button)
    }, true)

    document.addEventListener('submit', event => {
        const form = event.target
        const button = event.submitter || form.querySelector('button[name="checkout"]')
        if (!button || !form.querySelector('button[name="checkout"]')) return
        if (skipNextSubmit) {
            skipNextSubmit = false
            return
        }
        interceptCheckout(event, button)
    }, true)

    dialog.addEventListener('click', event => {
        if (event.target === dialog || event.target.closest('[data-upsell-continue]')) continueToCheckout()
    })

    dialog.addEventListener('cancel', event => {
        event.preventDefault()
        continueToCheckout()
    })

    dialog.addEventListener('change', event => {
        const select = event.target.closest('[data-upsell-variant]')
        if (!select) return
        const card = select.closest('[data-upsell-card]')
        const option = select.options[select.selectedIndex]
        const price = card.querySelector('[data-upsell-price]')
        const compare = card.querySelector('[data-upsell-compare]')
        price.textContent = option.dataset.price || ''
        compare.textContent = option.dataset.comparePrice || ''
        compare.hidden = !option.dataset.comparePrice
    })

    dialog.addEventListener('click', async event => {
        const button = event.target.closest('[data-upsell-add]')
        if (!button) return
        const card = button.closest('[data-upsell-card]')
        const variantSelect = card.querySelector('[data-upsell-variant]')
        const variantId = variantSelect ? variantSelect.value : button.dataset.variantId
        const errorMessage = card.querySelector('[data-upsell-error]')
        button.disabled = true
        button.textContent = button.dataset.loadingText
        if (errorMessage) errorMessage.hidden = true
        try {
            const response = await fetch(dialog.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
            })
            if (!response.ok) throw new Error('Could not add product')
            if (typeof window.refreshCartContents === 'function' && document.querySelector('#offcanvas-cart .offcanvas-body')) {
                try {
                    await window.refreshCartContents(response)
                } catch (error) {
                    window.location.reload()
                    return
                }
            }
            card.hidden = true
            updateEmptyMessage()
        } catch (error) {
            button.disabled = false
            button.textContent = button.dataset.addText
            if (errorMessage) errorMessage.hidden = false
        }
    })
})()
